export default {
  meta: {
    title: 'Our team',
    description: `The IEFA has focused on building a global, experienced team from across the worlds of business, government and academia.`
  },
  header: {
    title: 'Our team',
    content:
      'The IEFA has focused on building a global, experienced team from across the worlds of business, government and academia.'
  },
  cta: {
    title: 'Be a part of the team',
    content: 'The organization is growing at pace and welcomes interested applicants to share their resume.',
    button: 'Send my Resume'
  },
  members: [
    {
      name: 'Nicholas Rémillard',
      title: 'Chief Executive Officer',
      info: 'International Economic Forum of the Americas',
      image: '/images/team/Nicholas_Remillard-2636_HR.jpg'
    },
    {
      name: 'Gil Rémillard',
      title: 'Founding Chairman',
      info: 'International Economic Forum of the Americas',
      image: '/images/team/Gil_Remillard-2292_HR.jpg'
    },
    {
      name: 'Marie DuPont',
      title: 'Senior Financial Advisor',
      info: 'International Economic Forum of the Americas',
      image: '/images/person-thumbnail.png'
    },
    {
      name: 'Thaïs Pinto',
      title: 'President and Chief Legal Officer',
      info: 'International Economic Forum of the Americas',
      image: '/images/team/ThaisPinto.png'
    },
    {
      name: 'Mathieu Rondeau',
      title: 'Chief Financial Officer',
      info: 'International Economic Forum of the Americas',
      image: '/images/team/MathieuRondeau.png'
    },
    {
      name: 'Alain Dufour',
      title: 'Vice President, Production and Experience',
      info: 'International Economic Forum of the Americas',
      image: '/images/team/AlainDufour.jpg'
    },
    {
      name: 'Francisca Insulza',
      title: 'Vice President, Partner Relations and Strategic Growth',
      info: 'International Economic Forum of the Americas',
      image: '/images/team/FranciscaInsulza.jpg'
    },
    {
      name: 'Cédric Muller',
      title: 'Vice President, Content and External Affairs',
      info: 'International Economic Forum of the Americas',
      image: '/images/team/CedrickMuller.jpg'
    },
    {
      name: 'Francesco Biondi-Morra di Belforte',
      title: 'Director, Program and Content',
      info: 'International Economic Forum of the Americas',
      image: '/images/team/Francesco Biondi-Morra di Belforte.png'
    },
    {
      name: 'Éric Buchlin',
      title: 'Director of Security and Protocol',
      info: 'International Economic Forum of the Americas',
      image: '/images/team/ericBuchlin.jpg'
    },
    {
      name: 'Rebecca Durnin',
      title: 'Director of Communications and Marketing',
      info: 'International Economic Forum of the Americas',
      image: '/images/team/RebeccaDurnin.jpg'
    },
    {
      name: 'Rafael Moya Herrero',
      title: 'Senior Advisor, Program and Content',
      info: 'International Economic Forum of the Americas',
      image: '/images/team/rafael-moya-herrero.jpg'
    },
    {
      name: 'Benjamin Booth',
      title: 'Executive Advisor',
      info: 'International Economic Forum of the Americas',
      image: '/images/team/benjamin-booth.JPG'
    },
    {
      name: 'Laure Duque',
      title: 'Project Manager, Participation and Community of Interest Development Projects',
      info: 'International Economic Forum of the Americas',
      image: '/images/team/LaureDuque.jpg'
    },
    {
      name: 'Myriam Tannous',
      title: 'Project Manager, Communications and Marketing',
      info: 'International Economic Forum of the Americas',
      image: '/images/team/myriam-tannous.jpg'
    },
    {
      name: 'Noémie Baillarguet',
      title: 'Advisor, Marketing and Communication',
      info: 'International Economic Forum of the Americas',
      image: '/images/team/Noémie Baillarguet.jpg'
    },
    {
      name: 'Lyonel Millien',
      title: 'Controller Assistant',
      info: 'International Economic Forum of the Americas',
      image: '/images/team/lyonel-millien.jpg'
    },
    {
      name: 'Aurore Saccagi',
      title: 'Advisor, Program and Content',
      info: 'International Economic Forum of the Americas',
      image: '/images/team/aurore-saccagi.jpg'
    },
    {
      name: 'Virgile Sylvain',
      title: 'Advisor, Partner Relations',
      info: 'International Economic Forum of the Americas',
      image: '/images/team/Virgile Sylvain.png'
    },
    {
      name: 'Joseph Clark',
      title: 'President',
      info: 'Toronto Global Forum',
      image: '/images/team/JosephClark.jpg'
    },
    {
      name: 'Ali Ponte',
      title: 'Executive Director',
      info: 'Toronto Global Forum',
      image: '/images/team/AliPonte.jpg'
    },
    {
      name: 'Bill Johnson',
      title: 'President',
      info: 'World Strategic Forum',
      image: '/images/team/BillJohnson.png'
    },
    {
      name: 'Julia Bernstein',
      title: 'Executive Director',
      info: 'World Strategic Forum',
      image: '/images/team/julia-bernstein.jpeg'
    },
    {
      name: 'Céline Boyard',
      title: 'Executive Director',
      info: 'The Conference of Paris',
      image: '/images/team/CelineBoyard.png'
    },
    {
      name: 'Dorothée Pineau',
      title: 'Corporate Advisor',
      info: 'The Conference of Paris',
      image: '/images/team/DorothéePineau.jpg'
    }
  ]
}
